const BIG = {
  tag: "直播复盘",
  title: "收官夜热搜五连挂，观众逐秒抠出三处「节目效果」",
  meta: "4 小时前 · 围观 18.6w",
  excerpt: "从广告口播嘴瓢到镜头语言调度，一场直播让技术组、导演组与后期集体上桌。网友搬出时间轴逐帧复盘，评论区已然变成一场细节鉴伪大赛。",
  img: "https://readdy.ai/api/search-image?query=Empty%20television%20studio%20set%20with%20glowing%20warm%20lights%20and%20monitors%20displaying%20blurred%20live%20broadcast%20signals%2C%20silhouette%20of%20production%20crew%2C%20editorial%20media%20magazine%20photography%2C%20cinematic%20warm%20orange%20lighting%2C%20dramatic%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=1200&height=760&seq=discuss-big-58&orientation=landscape",
};

const SMALL = [
  {
    tag: "情感",
    title: "调解节目「开撕名场面」被断章，原片评论区吵翻了",
    heat: "4.9w",
    img: "https://readdy.ai/api/search-image?query=Two%20silhouetted%20people%20sitting%20at%20opposite%20ends%20of%20a%20table%20under%20a%20single%20warm%20desk%20lamp%2C%20tense%20yet%20styled%20editorial%20illustration%2C%20warm%20crimson%20and%20amber%20tone%2C%20magazine%20cover%20photography%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=640&height=420&seq=discuss-s1-58&orientation=landscape",
  },
  {
    tag: "商界",
    title: "门店排队照被指摆拍，连锁回应「欢迎随时来数人头」",
    heat: "3.8w",
    img: "https://readdy.ai/api/search-image?query=Long%20queue%20of%20customers%20waiting%20outside%20a%20modern%20restaurant%20at%20night%2C%20warm%20storefront%20neon%20glow%2C%20documentary%20street%20photography%2C%20cinematic%20warm%20tone%2C%20candid%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=640&height=420&seq=discuss-s2-58&orientation=landscape",
  },
  {
    tag: "体娱",
    title: "赛后握手名场面刷屏，体育解说直播开麦逐句分析",
    heat: "5.2w",
    img: "https://readdy.ai/api/search-image?query=Empty%20stadium%20with%20bright%20floodlights%20after%20a%20match%2C%20silhouette%20of%20two%20athletes%20shaking%20hands%20center%20court%2C%20editorial%20sports%20magazine%20photography%2C%20warm%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=640&height=420&seq=discuss-s3-58&orientation=landscape",
  },
  {
    tag: "科技",
    title: "新功能上线即被玩坏，官方急发「请理性使用」声明",
    heat: "4.1w",
    img: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20close%20up%20glowing%20with%20abstract%20interface%20reflections%2C%20fingers%20tapping%2C%20dark%20warm%20background%2C%20tech%20editorial%20magazine%20photography%2C%20dramatic%20orange%20light%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=640&height=420&seq=discuss-s4-58&orientation=landscape",
  },
];

export default function Discuss() {
  return (
    <section id="discuss" className="border-t border-background-200/70 bg-background-100/50 py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-5 md:mb-6">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-chat-heart-line" aria-hidden="true"></i>
            </span>
            <div>
              <h2 className="font-display font-black text-foreground-950 text-2xl md:text-3xl">热议进行时</h2>
              <p className="text-xs text-foreground-500 mt-1">大小瓜混排 · 前排围观区</p>
            </div>
          </div>
          <div className="flex items-center gap-2 text-xs">
            <span className="flex items-center gap-1 rounded-full bg-accent-100 text-accent-700 px-3 py-1.5 font-medium">
              <i className="ri-fire-fill" aria-hidden="true"></i> 今日全站爆 6 条
            </span>
            <span className="flex items-center gap-1 rounded-full bg-secondary-100 text-secondary-800 px-3 py-1.5 font-medium">
              <i className="ri-eye-line" aria-hidden="true"></i> 实时围观中
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          {/* 大卡：通栏主视觉 */}
          <article className="group relative overflow-hidden rounded-2xl min-h-[300px] lg:row-span-2 lg:min-h-0">
            <img
              src={BIG.img}
              alt={BIG.title}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
            <div className="absolute top-4 left-4 rounded-full bg-background-50/90 text-primary-700 text-xs font-bold px-3 py-1">{BIG.tag}</div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h3 className="font-display font-bold text-background-50 text-lg md:text-2xl leading-snug">{BIG.title}</h3>
              <p className="mt-2 text-background-50/80 text-sm leading-relaxed line-clamp-2 hidden md:block">{BIG.excerpt}</p>
              <p className="mt-3 flex items-center gap-4 text-[11px] text-background-50/75">{BIG.meta}</p>
            </div>
          </article>

          {/* 小卡：2x2 */}
          {SMALL.map((s) => (
            <article
              key={s.title}
              className="group overflow-hidden rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative h-36 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <span className="absolute top-3 left-3 rounded-full bg-accent-500 text-background-50 text-[11px] font-bold px-2.5 py-0.5">{s.tag}</span>
                <span className="absolute top-3 right-3 flex items-center gap-1 rounded-full bg-foreground-950/50 text-background-50 text-[11px] px-2.5 py-0.5">
                  <i className="ri-fire-line" aria-hidden="true"></i> {s.heat}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-950 text-sm leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">{s.title}</h3>
                <p className="flex items-center gap-1.5 mt-3 text-[11px] text-foreground-500">
                  <i className="ri-chat-3-line" aria-hidden="true"></i> 前排围观
                  <span className="ml-auto rounded-full bg-secondary-100 text-secondary-700 px-2 py-0.5">进热评</span>
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}